import React from 'react'
import { type ReactNode } from 'react'
import styled, { css } from 'styled-components'

type SeriesLabelProps = {
  isSelected?: boolean
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  series: Record<string, any>
  disable: boolean
  onSelectSeriesCallback?: (name: string, val: boolean) => void
  className?: string
}

const SeriesLabel = ({ isSelected = false, disable, series, className = '', onSelectSeriesCallback = () => {} }: SeriesLabelProps) => {
  const onClickLabel = () => {
    if (!disable) {
      onSelectSeriesCallback(series.seriesName as string, !isSelected)
    }
  }

  return (
    <S.Label {...{ isSelected, className, disable }} onClick={onClickLabel}>
      {series.icon
        ? series.icon as ReactNode
        : (
          <svg width="30px" height="6px" xmlns="http://www.w3.org/2000/svg">
            <line
                x1={series.x1}
                y1={series.y1}
                x2={series.x2}
                y2={series.y2}
                stroke={series.stroke}
                strokeWidth={series.strokeWidth}
                strokeDasharray={series.strokeDasharray}
                strokeLinecap={series.strokeLineCap}
            />
          </svg>
        )
      }

      <span>{series.label}</span>
    </S.Label>
  )
}

export default SeriesLabel

const S = {
  Label: styled.span.withConfig({
    shouldForwardProp: (prop) => !['isSelected', 'disable'].includes(prop)
  })<{ isSelected?: boolean; disable?: boolean }>`
    display: inline-block;
    cursor: pointer;
    ${({ disable }) => (disable && css`
      opacity: 0.4;
      pointer-events: none;
    `)}

    ${({ isSelected, disable }) =>
    (
      isSelected && !disable
        ? css`font-weight: bold;`
        : css`letter-spacing: .31px;

          &:hover {
            letter-spacing: normal;
            font-weight: 600;
          }
        `
    )}
`
}
